const btoaToken = (email, password) => {
  let token
  try {
    token = window.btoa(`${email}:${password}`)
  } catch (error) {
    const deferred = Promise.defer()
    return deferred.reject({ status: 400, message: error })
  }

  return token
}

export default btoaToken
